import clientConfigApi from '../config/config'
import axios from 'axios';
//import { token } from '../config/constant';

export const fetchChannelList = (path, chanSchHours, token, callback) => {
  console.log("path, chanSchHours", path, chanSchHours);
  let channelList = {}
  return async dispatch => {
    channelList = await clientConfigApi.post(
      path,
      {
        "payload": {},
        "header": {
          "sessionToken": token/*"9af51514-2fa9-4f07-87b1-e509f34646d3"*/,
          'compressedResponse': "false",
          'scheduleDuration': `${chanSchHours}`
        },
      },
      {
        headers: {
          "Authorization": `Bearer ${localStorage.getItem("tvRemotwAuthToken")}`
        }
      }
    )
      .catch(
        ({ response = {} }) => {
          console.log("Api failed with the status code:", response);
          if(window.FireBasePlugin){
            // window.FirebasePlugin.logMessage("deviceConfig API failed using faceBasedJson() face data = " + faceData + "response = " + response);
            window.FirebasePlugin.logError("TV Channel Api failed with the status code: " , response)
          }
        }
      )
    console.log("channelList", channelList.data);
    if (channelList && channelList.data) {
      dispatch({
        type: 'Fetch_Channels_Data',
        payload: {
          channelData: channelList.data.channelData,
          languageGrouping:channelList.data.languageGrouping,
          categoryGrouping:channelList.data.categoryGrouping,
          currentChannel: channelList.data.channelData[0]
        }
      })
      callback && callback(true)
    }
  }
}

export const currentChannelAction = (currentChannel) => {
  return {
    type: 'Current_Channels_Data',
    payload: currentChannel
  }
}

export const getremoteAccessToken = (roomDetails, callBackForColor, callback) => {

  let responseData;
  let room = localStorage.getItem("room");
  try {
    return dispatch => {
      if (room && room !== "null") {
        if (!roomDetails || !roomDetails.devices) {
          clientConfigApi.post(
            "/remote/getRemoteSessionToken",
            {
              "header": {
                "locationNumber": room
              },
              "payload": {}
            },
            {
              headers: {
                "Authorization": `Bearer ${localStorage.getItem("tvRemotwAuthToken")}`
              }
            }

          ).then((responseData) => {
            if (responseData && responseData.data) {
              roomDetails = responseData.data.payload
              console.log("roomDetails in", roomDetails);
              //localStorage.setItem("roomDetails", JSON.stringify(roomDetails));
              dispatch({
                type: 'Room_Remote_Details',
                payload: roomDetails.devices
              }
              );
              // callBackForColor();
            }
            callback(true);
          })
            .catch(
              (response) => {
                console.log("Api failed with the status code:", response);
                callback(false);
          }
            )
        }
      }
    }
  } catch (e) {
    console.log("error in getremoteAccessToken", e)
  }
}

export const setTvToken = (token) => {
  return {
    type: 'Set_TV_Token',
    payload: token
  }
}

export const setCurrentTV = (TVdata) => {
  return {
    type: 'Set_Current_TV',
    payload: TVdata
  }
}

export const setNextTV = (TVdata) => {
  return {
    type: 'Set_Next_TV',
    payload: TVdata
  }
}

export const fetchIPTVChannelList = (sessionToken) => {
  let responseData;
  let room = localStorage.getItem("room");
  return async dispatch => {
    if (room && room !== "null") {

      responseData = await clientConfigApi.post(
        "channelList/fetch",
        {
          "header": {
            "sessionToken": sessionToken,
            "locationNumber": room
          },
          "payload": {}
        },
        {
          headers: {
            "Authorization": `Bearer ${localStorage.getItem("tvRemotwAuthToken")}`
          }
        }

      )
        .catch(
          (response) => {
            console.log("Api failed with the status code:", response);
          }
        )
      console.log("IPTV response in", responseData);
      if (responseData && responseData.data) {

        dispatch({
          type: 'Fetch_Channels_Data',
          payload: {
            channelData: responseData.data.channelList,
            currentChannel: responseData.data.channelList[0]
          }
        })
      }
    }
  }
}

// vr_int_rapi
// 76211440c342f768rLnCsJXd5ecc97f4ea74866c

export const getTVRemoteAuthToken = (callback) => {
  return async dispacth => {
      clientConfigApi.post(
          "/remoteControl/authenticate",
          {
            "payload": {
              "name":"gj_rapi",
              "authCode":"4597572ad2bfe858TOC4AhwX08034738433983b8"
            }
          }        
      ).then((response = {}) => {
        console.log("response.data",response.data)
        if(response && response.data && response.data.payload){
          dispacth({
            type: "Set_TV_Remote_Auth_Token",
            payload: response.data.payload.token
          })
          localStorage.setItem("tvRemotwAuthToken", response.data.payload[0].token)
          callback(true)
        }
      }).catch(() => {
        if(callback){
          callback(false)
        }
      })
  }
}

export const validateGuestForTVRemote = (guestName, guestLocation, callback) => {
  return async dispacth => {
      clientConfigApi.post(
          "/remoteControl/guest/validate",
          {
            "header": {
              "guestName": guestName,
              "location": guestLocation
            },
            "payload": {
              "guestDeviceIP": "",
              "guestDeviceMac": ""
            }
          },
          {
            headers: {
              "Authorization": `Bearer ${localStorage.getItem("tvRemotwAuthToken")}`
            }
          }
      ).catch(() => {
        if(callback){
          callback(false)
        }
      })
  }
}